const ListaGerentesProjeto = [
    { nome: "Fernando Horta Latini", email: "ti@conticonsultoria.com.br" },
    { nome: "Leandro Pereira Lucas", email: "ti@conticonsultoria.com.br" },
    { nome: "Roberto Marcio Vasconcelos Santos", email: "ti@conticonsultoria.com.br" },
    { nome: "Bruna Roberta da Silva", email: "ti@conticonsultoria.com.br" },
    { nome: "Luciano Neves de Mendonca", email: "ti@conticonsultoria.com.br" },
    { nome: "Pedro Augusto da Silva Carneiro", email: "ti@conticonsultoria.com.br" },
    { nome: "Simone Maria Lopes", email: "ti@conticonsultoria.com.br" },
    { nome: "Michelle Cardoso Nunes Aun", email: "ti@conticonsultoria.com.br" }
];

export default ListaGerentesProjeto;
